import { Category } from './categoriesList'


export const URL = '/v2/pms/accomodations/:id/room_categories/'

export type Req = {
  name: string
  attributes?: string[]
  balcon?: boolean
  conditioner?: 0 | 1
  description?: string
  extra_person_qty?: number
  fridge?: boolean
  kitchen?: boolean
  person_qty?: number
  room_qty?: number
  square?: number
  toilet?: undefined
  tv?: boolean
}

export type Resp = Category